import type { SiteContent } from '@/lib/cms-types';
import { mergeSiteWithDefaults } from '@/lib/site-defaults';

const SITE_CACHE_KEY = 'xat-help-site-cache-v1';

/** Último site CMS conhecido (evita flash dos defaults no F5). */
export function readCachedSiteContent(): SiteContent | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(SITE_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SiteContent;
    if (!parsed || typeof parsed !== 'object') return null;
    return mergeSiteWithDefaults(parsed);
  } catch {
    return null;
  }
}

export function writeCachedSiteContent(site: SiteContent): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(SITE_CACHE_KEY, JSON.stringify(site));
  } catch {
    /* quota / private mode */
  }
}
